module.exports = __webpack_public_path__ + "static/media/arrowOpen.6ceef0af.svg";